import classNames from "classnames";
import React from "react";

type Props = {
  title: string | JSX.Element;
  extraClasses?: string;
  titleClasses?: string;
};

export const PageLayout: React.FC<Props> = ({
  title,
  children,
  extraClasses,
  titleClasses,
}) => {
  return (
    <div className={classNames("w-full overflow-hidden pb-10", extraClasses)}>
      <h1 className={classNames("text-3xl font-bold", titleClasses)}>
        {title}
      </h1>
      {children}
    </div>
  );
};
